<template>
  <div class="dash">
    <el-row :gutter="20" class="dash__row1">
      <el-col :xs="24" :lg="9">
        <div class="dash-balance">
          <div class="dash-balance__row1">
            <span class="dash-balance__label">累计成交额</span>
            <span
              v-if="balanceTrend.text"
              class="dash-balance__pill"
              :class="{
                'is-up': balanceTrend.dir === 'up',
                'is-down': balanceTrend.dir === 'down',
                'is-flat': balanceTrend.dir === 'flat'
              }"
            >
              <img
                v-if="balanceTrend.dir && balanceTrend.dir !== 'flat'"
                class="dash-balance__pill-ico"
                :src="sliceDb(balanceTrend.dir === 'down' ? 'drop.png' : 'rise.png')"
                alt=""
              />
              {{ balanceTrend.text }}
            </span>
          </div>
          <div class="dash-balance__value">{{ formatDec(platformTotalUsdt) }} USDT</div>
          <div class="dash-balance__hint">全平台（已确认及之后）</div>
          <div class="dash-balance__stats">
            <div>
              <div class="dash-balance__subl">今日收入</div>
              <div class="dash-balance__subv">+{{ formatUsdt(todayUsdt) }}</div>
            </div>
            <div>
              <div class="dash-balance__subl">本月收入</div>
              <div class="dash-balance__subv">{{ formatUsdt(monthUsdt) }}</div>
            </div>
            <div>
              <div class="dash-balance__subl">商户 / 正常</div>
              <div class="dash-balance__subv">{{ formatInt(totalMerchants) }} / {{ formatInt(normalMerchants) }}</div>
            </div>
          </div>
          <el-button class="dash-balance__btn" @click="$router.push('/orders')">
            查看全部订单
          </el-button>
        </div>
      </el-col>
      <el-col :xs="24" :lg="15">
        <el-row :gutter="16" class="dash-metrics">
          <el-col v-for="card in metricCardList" :key="card.key" :xs="24" :sm="12">
            <div class="metric-card">
              <div class="metric-card__head">
                <div class="metric-card__head-left">
                  <img class="metric-card__ico" :src="sliceDb(card.icon)" alt="" role="presentation" />
                  <span class="metric-card__title">{{ card.title }}</span>
                </div>
                <el-select v-model="statRange" size="mini" class="metric-card__sel" popper-class="metric-card-sel-popper">
                  <el-option label="今日" value="今日" />
                  <el-option label="本周" value="本周" />
                  <el-option label="本月" value="本月" />
                </el-select>
              </div>
              <div class="metric-card__data-row">
                <div class="metric-card__value-line">
                  <span class="metric-card__num">{{ cardValue(card) }}</span>
                  <span v-if="card.unit" class="metric-card__unit">{{ card.unit }}</span>
                </div>
                <div
                  v-if="cardTrend(card).text"
                  class="metric-card__pill"
                  :class="pillClass(cardTrend(card))"
                >
                  <img
                    v-if="cardTrend(card).dir && cardTrend(card).dir !== 'flat'"
                    class="metric-card__pill-ico"
                    :src="sliceDb(trendIconName(cardTrend(card).dir))"
                    alt=""
                  />
                  <span class="metric-card__pill-txt">{{ cardTrend(card).text }}</span>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="dash__row2">
      <el-col :xs="24" :lg="9">
        <div class="dash-panel">
          <div class="dash-panel__h">累计收入占比</div>
          <div ref="pieRef" class="dash-panel__chart dash-panel__chart--pie" />
          <div class="dash-legend">
            <div
              v-for="c in incomeMiniCards"
              :key="c.coin"
              :class="['dash-legend__item', 'tone-' + c.tone]"
            >
              <span class="dash-legend__coin">{{ c.coin }}</span>
              <span class="dash-legend__line">{{ c.pctLine }}</span>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :lg="15">
        <div class="dash-panel">
          <div class="dash-panel__head">
            <div>
              <div class="dash-panel__h">收入趋势分析</div>
            </div>
            <el-radio-group v-model="trendRange" size="small">
              <el-radio-button label="今日" />
              <el-radio-button label="本周" />
              <el-radio-button label="本月" />
            </el-radio-group>
          </div>
          <div class="dash-panel__legend">
            <span><i class="lgd lgd--btc" />BTC</span>
            <span><i class="lgd lgd--eth" />ETH</span>
            <span><i class="lgd lgd--usdt" />USDT</span>
          </div>
          <div ref="lineRef" class="dash-panel__chart" />
        </div>
      </el-col>
    </el-row>

    <div class="dash-panel dash-table-wrap">
      <div class="dash-panel__head">
        <div>
          <div class="dash-panel__h">最近订单</div>
        </div>
        <router-link class="dash-panel__all" to="/orders">查看全部 <span class="arr">→</span></router-link>
      </div>
      <el-table :data="orderRows" class="dash-table" style="width: 100%" size="small">
        <el-table-column prop="merchantName" label="商户" min-width="120">
          <template slot-scope="scope">
            <span class="cell-muted">{{ scope.row.merchantName || '—' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="userId" label="用户标识" min-width="100">
          <template slot-scope="scope">
            <span class="cell-muted">{{ scope.row.userId }}</span>
          </template>
        </el-table-column>
        <el-table-column label="币种" width="96">
          <template slot-scope="scope">
            <span class="coin-pill" :class="'coin-pill--' + String(scope.row.coin || '').toLowerCase()">
              <img v-if="coinIcon(scope.row.coin)" :src="coinIcon(scope.row.coin)" alt="" class="coin-pill__ico" />
              {{ scope.row.coin }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="chain" label="链" width="100">
          <template slot-scope="scope">
            <span class="chain-pill">{{ scope.row.chain }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="amount" label="金额" min-width="120" />
        <el-table-column prop="address" label="地址" min-width="200">
          <template slot-scope="scope">
            <explorer-cell kind="address" :chain="scope.row.chain" :value="scope.row.address" />
          </template>
        </el-table-column>
        <el-table-column prop="txHash" label="交易 HASH" width="120">
          <template slot-scope="scope">
            <explorer-cell kind="tx" :chain="scope.row.chain" :value="scope.row.txHash" />
          </template>
        </el-table-column>
        <el-table-column prop="usdt" label="换算 USDT" min-width="110" />
        <el-table-column label="创建时间" min-width="150">
          <template slot-scope="scope">
            <span class="cell-muted cell-time">{{ timeLine(scope.row.createdAt) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="到账时间" min-width="150">
          <template slot-scope="scope">
            <span class="cell-time cell-arrival">{{ timeLine(scope.row.arrivedAt) }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { adminApi } from '@/api/admin'
import ExplorerCell from '@/components/ExplorerCell.vue'

const COL = { btc: '#e879c9', eth: '#60a5fa', usdt: '#22d3ee' }

export default {
  name: 'AdminDashboardView',
  components: { ExplorerCell },
  data() {
    return {
      statRange: '本周',
      trendRange: '本周',
      /** 与 UI 图一致：四卡标题与切图，右侧各自下拉共用 statRange */
      metricCardList: [
        { key: 'orders', title: '订单总数', icon: 'orders_number.png', unit: '单' },
        { key: 'amount', title: '成交额', icon: 'orders_amount.png', unit: 'USDT' },
        { key: 'mcount', title: '商户总数', icon: 'merchant.png', unit: '家' },
        { key: 'mnormal', title: '正常商户', icon: 'normal.png', unit: '家' }
      ],
      totalMerchants: 0,
      normalMerchants: 0,
      platformTotalUsdt: '0.00',
      lastWeekOrders: null,
      lastWeekUsdt: null,
      lastMonthOrders: null,
      lastMonthUsdt: null,
      orderRows: [],
      todayUsdt: '0.00',
      monthUsdt: '0.00',
      thisMonthIncomeUsdt: '0.00',
      lastMonthIncomeUsdt: '0.00',
      todayOrders: 0,
      yesterdayOrders: 0,
      weekOrders: 0,
      monthOrders: 0,
      todayUsdt2: 0,
      yesterdayUsdt: 0,
      weekUsdt: '0.00',
      monthUsdt2: '0.00',
      incomeMiniCards: [
        { coin: 'ETH', amount: '0', pctLine: '—', tone: 'eth' },
        { coin: 'BTC', amount: '0', pctLine: '—', tone: 'btc' },
        { coin: 'USDT', amount: '0.00', pctLine: '—', tone: 'usdt' }
      ],
      pieChart: null,
      lineChart: null
    }
  },
  computed: {
    balanceTrend() {
      return this.fmtMonthOverMonth(this.thisMonthIncomeUsdt, this.lastMonthIncomeUsdt)
    },
    metricOrdersVal() {
      if (this.statRange === '本周') return this.weekOrders
      if (this.statRange === '本月') return this.monthOrders
      return this.todayOrders
    },
    metricAmountVal() {
      if (this.statRange === '本周') return this.weekUsdt
      if (this.statRange === '本月') return this.monthUsdt2
      return String(this.todayUsdt2)
    },
    ordersMiniTrend() {
      if (this.statRange !== '今日') return { text: '', dir: 'flat' }
      return this.fmtDayOverDayNum(this.todayOrders, this.yesterdayOrders)
    },
    usdtMiniTrend() {
      if (this.statRange !== '今日') return { text: '', dir: 'flat' }
      return this.fmtDayOverDayNum(parseFloat(this.todayUsdt2), parseFloat(this.yesterdayUsdt))
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initPie()
      this.initLine()
      this.loadAll()
      window.addEventListener('resize', this.resizeCharts)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeCharts)
    this.pieChart && this.pieChart.dispose()
    this.lineChart && this.lineChart.dispose()
  },
  watch: {
    trendRange() {
      this.loadDashboard()
    }
  },
  methods: {
    base() {
      return process.env.BASE_URL || '/'
    },
    sliceDb(name) {
      return this.base() + 'slices/dashboard/' + encodeURIComponent(name)
    },
    coinIcon(coin) {
      const u = String(coin || '').toUpperCase()
      if (u === 'BTC') return this.base() + 'slices/btc.png'
      if (u === 'ETH') return this.base() + 'slices/eth.png'
      if (u === 'USDT') return this.base() + 'slices/usdt.png'
      return ''
    },
    formatDec(s) {
      const n = parseFloat(s)
      if (!Number.isFinite(n)) return '0.00'
      return n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    formatUsdt(s) {
      return this.formatDec(s)
    },
    formatInt(n) {
      return Number(n || 0).toLocaleString('en-US')
    },
    cardValue(card) {
      if (card.key === 'orders') {
        return this.formatInt(this.metricOrdersVal)
      }
      if (card.key === 'amount') {
        return this.formatDec(String(this.metricAmountVal))
      }
      if (card.key === 'mcount') {
        return this.formatInt(this.totalMerchants)
      }
      if (card.key === 'mnormal') {
        return this.formatInt(this.normalMerchants)
      }
      return '—'
    },
    cardTrend(card) {
      const k = card.key
      if (k === 'mcount' || k === 'mnormal') {
        return { text: '', dir: 'flat' }
      }
      if (this.statRange === '今日') {
        if (k === 'orders') return this.ordersMiniTrend
        if (k === 'amount') return this.usdtMiniTrend
      }
      if (this.statRange === '本周') {
        if (k === 'orders' && this.lastWeekOrders != null) {
          return this.fmtPeriodCompare(this.weekOrders, this.lastWeekOrders, '上周')
        }
        if (k === 'amount' && this.lastWeekUsdt != null) {
          return this.fmtPeriodCompare(parseFloat(this.weekUsdt) || 0, this.lastWeekUsdt, '上周')
        }
      }
      if (this.statRange === '本月') {
        if (k === 'orders' && this.lastMonthOrders != null) {
          return this.fmtPeriodCompare(this.monthOrders, this.lastMonthOrders, '上月')
        }
        if (k === 'amount' && this.lastMonthUsdt != null) {
          return this.fmtPeriodCompare(parseFloat(this.monthUsdt2) || 0, this.lastMonthUsdt, '上月')
        }
      }
      return { text: '', dir: 'flat' }
    },
    /** UI 图：下降=绿、上升=红；dir=down 表示当期低于对比期 */
    fmtPeriodCompare(cur, prev, label) {
      const t = Number(cur)
      const p = Number(prev)
      if (p === 0 && t === 0) {
        return { text: '', dir: 'flat' }
      }
      if (p === 0) {
        return { text: `较${label} 新增`, dir: 'up' }
      }
      const pct = ((t - p) / p) * 100
      const up = pct > 0
      return {
        text: `较${label}${up ? '上升' : '下降'}${Math.abs(pct).toFixed(1)}%`,
        dir: up ? 'up' : 'down'
      }
    },
    pillClass(t) {
      if (!t || t.dir === 'flat' || !t.text) {
        return {}
      }
      return t.dir === 'down' ? { 'is-down-pill': true } : { 'is-up-pill': true }
    },
    trendIconName(dir) {
      if (dir === 'down') {
        return 'drop.png'
      }
      if (dir === 'up') {
        return 'rise.png'
      }
      return 'rise.png'
    },
    formatCompact(n) {
      const x = parseFloat(n) || 0
      if (x >= 1e6) return (x / 1e6).toFixed(2) + 'M'
      if (x >= 1e3) return (x / 1e3).toFixed(2) + 'K'
      return this.formatDec(n)
    },
    fmtMonthOverMonth(thisM, lastM) {
      const t = parseFloat(thisM)
      const l = parseFloat(lastM)
      if (l === 0 && t === 0) return { text: '较上月 持平', dir: 'flat' }
      if (l === 0) return { text: '较上月 新增', dir: 'up' }
      const pct = ((t - l) / l) * 100
      const sign = pct >= 0 ? '+' : ''
      return {
        text: `较上月${pct >= 0 ? '上升' : '下降'}${sign}${Math.abs(pct).toFixed(1)}%`,
        dir: pct >= 0 ? 'up' : 'down'
      }
    },
    fmtDayOverDayNum(today, yest) {
      const t = Number(today)
      const y = Number(yest)
      if (y === 0 && t === 0) return { text: '较昨日 持平', dir: 'flat' }
      if (y === 0) return { text: '较昨日 新增', dir: 'up' }
      const pct = ((t - y) / y) * 100
      const up = pct > 0
      return {
        text: `较昨日${up ? '上升' : '下降'}${Math.abs(pct).toFixed(1)}%`,
        dir: up ? 'up' : 'down'
      }
    },
    async loadAll() {
      await this.loadDashboard()
      await this.loadRecentOrders()
    },
    mapRange() {
      return { 今日: 'today', 本周: 'week', 本月: 'month' }[this.trendRange] || 'week'
    },
    async loadDashboard() {
      try {
        const res = await adminApi.dashboard({ range: this.mapRange() })
        const d = res.data
        this.platformTotalUsdt = d.total_usdt != null ? String(d.total_usdt) : '0.00'
        this.totalMerchants = d.total_merchants != null ? Number(d.total_merchants) : 0
        this.normalMerchants = d.normal_merchants != null ? Number(d.normal_merchants) : 0
        this.todayUsdt = d.today_usdt || '0.00'
        this.monthUsdt = d.month_usdt || d.this_month_income_usdt || '0.00'
        this.thisMonthIncomeUsdt = d.this_month_income_usdt || '0.00'
        this.lastMonthIncomeUsdt = d.last_month_income_usdt || '0.00'
        this.todayOrders = d.today_orders || 0
        this.yesterdayOrders = d.yesterday_orders || 0
        this.weekOrders = d.week_orders || 0
        this.monthOrders = d.month_orders || 0
        this.todayUsdt2 = parseFloat(d.today_usdt) || 0
        this.yesterdayUsdt = parseFloat(d.yesterday_usdt) || 0
        this.weekUsdt = d.week_usdt || '0.00'
        this.monthUsdt2 = d.month_usdt || '0.00'
        this.lastWeekOrders = null
        this.lastWeekUsdt = null
        this.lastMonthOrders = d.last_month_orders != null ? Number(d.last_month_orders) : null
        this.lastMonthUsdt = d.last_month_usdt != null ? parseFloat(d.last_month_usdt) : null
        this.applyIncomeMini(d)
        this.$nextTick(() => {
          this.refreshPie(d)
          this.refreshLine(d.line_chart)
        })
      } catch (e) {
        /* 保持默认 */
      }
    },
    applyIncomeMini(d) {
      const statsMap = { BTC: 0, ETH: 0, USDT: 0 }
      for (const c of d.coin_stats || []) {
        const coin = String(c.coin || '')
          .trim()
          .toUpperCase()
        if (statsMap[coin] !== undefined) statsMap[coin] = parseFloat(c.total || 0)
      }
      const sum = statsMap.BTC + statsMap.ETH + statsMap.USDT
      const pct = (k) => (sum > 0 ? Math.round((statsMap[k] / sum) * 100) : 0) + '%'
      this.incomeMiniCards = [
        { coin: 'ETH', amount: '—', pctLine: `占比 ${pct('ETH')}`, tone: 'eth' },
        { coin: 'BTC', amount: '—', pctLine: `占比 ${pct('BTC')}`, tone: 'btc' },
        { coin: 'USDT', amount: '—', pctLine: `占比 ${pct('USDT')}`, tone: 'usdt' }
      ]
    },
    formatCompactUsdt(n) {
      const x = Number(n) || 0
      if (x >= 1e6) return (x / 1e6).toFixed(2) + 'M'
      if (x >= 1e3) return (x / 1e3).toFixed(2) + 'K'
      return x.toFixed(2)
    },
    refreshPie(d) {
      if (!this.pieChart) return
      const statsMap = { BTC: 0, ETH: 0, USDT: 0 }
      for (const c of d.coin_stats || []) {
        const coin = String(c.coin || '')
          .toUpperCase()
          .trim()
        if (Object.prototype.hasOwnProperty.call(statsMap, coin)) {
          statsMap[coin] = parseFloat(c.total || 0)
        }
      }
      let sum = statsMap.BTC + statsMap.ETH + statsMap.USDT
      const pieData = [
        { value: Math.max(0, statsMap.BTC), name: 'BTC', itemStyle: { color: COL.btc } },
        { value: Math.max(0, statsMap.ETH), name: 'ETH', itemStyle: { color: COL.eth } },
        { value: Math.max(0, statsMap.USDT), name: 'USDT', itemStyle: { color: COL.usdt } }
      ]
      if (sum <= 0) {
        pieData[0].value = pieData[1].value = pieData[2].value = 1
        sum = 3
      }
      const totalStr = this.formatCompactUsdt(sum) + ' USDT'
      this.pieChart.setOption({
        series: [
          {
            data: pieData,
            label: {
              show: true,
              position: 'center',
              formatter: '累计\n' + totalStr,
              color: '#0f172a',
              fontSize: 12,
              lineHeight: 20
            }
          }
        ]
      })
    },
    /** 折线数据点：先定点再转 Number，避免 JS 浮点与 tooltip 出现一长串小数 */
    roundLineVal(v) {
      const n = Number(v)
      if (!Number.isFinite(n)) return 0
      return Number(n.toFixed(2))
    },
    formatLineAxisNum(n) {
      const x = Number(n)
      if (!Number.isFinite(x)) return '0'
      if (Math.abs(x) >= 1e6) return (x / 1e6).toFixed(1) + 'M'
      if (Math.abs(x) >= 1e3) return (x / 1e3).toFixed(1) + 'K'
      return x % 1 === 0 ? String(Math.round(x)) : x.toFixed(2)
    },
    refreshLine(lc) {
      if (!this.lineChart || !lc) return
      const labels = lc.labels || []
      const s = lc.series || {}
      const btc = (s.BTC || []).map((x) => this.roundLineVal(x))
      const eth = (s.ETH || []).map((x) => this.roundLineVal(x))
      const usdt = (s.USDT || []).map((x) => this.roundLineVal(x))
      const all = [...btc, ...eth, ...usdt]
      const maxVal = Math.max(1, ...all)
      this.lineChart.setOption({
        xAxis: { data: labels },
        yAxis: { max: maxVal * 1.15 },
        series: [{ data: btc }, { data: eth }, { data: usdt }]
      })
    },
    async loadRecentOrders() {
      try {
        const res = await adminApi.orders({ page: 1, page_size: 30 })
        const list = (res.data.list || [])
          .filter((r) => Number(r.status) >= 1)
          .slice(0, 5)
        this.orderRows = list.map((r) => ({
          merchantName: (r.merchant && r.merchant.name) || '',
          userId: r.user_uid,
          coin: r.coin,
          chain: r.chain,
          amount: r.amount,
          address: r.address,
          txHash: r.tx_hash,
          usdt: r.amount_usdt,
          createdAt: r.created_at || r.chain_time,
          arrivedAt: r.confirmed_at || '—'
        }))
      } catch (e) {
        this.orderRows = []
      }
    },
    timeLine(s) {
      if (!s || typeof s !== 'string') return s || '—'
      const p = s.split(' ')
      return p.length >= 2 ? `${p[0]} ${p[1]}` : s
    },
    resizeCharts() {
      this.pieChart && this.pieChart.resize()
      this.lineChart && this.lineChart.resize()
    },
    initPie() {
      if (!this.$refs.pieRef) return
      this.pieChart = echarts.init(this.$refs.pieRef)
      this.pieChart.setOption({
        color: [COL.btc, COL.eth, COL.usdt],
        tooltip: { trigger: 'item' },
        series: [
          {
            type: 'pie',
            radius: ['52%', '72%'],
            avoidLabelOverlap: false,
            label: { show: true, position: 'center' },
            labelLine: { show: false },
            data: [
              { value: 1, name: 'BTC' },
              { value: 1, name: 'ETH' },
              { value: 1, name: 'USDT' }
            ]
          }
        ]
      })
    },
    initLine() {
      if (!this.$refs.lineRef) return
      this.lineChart = echarts.init(this.$refs.lineRef)
      this.lineChart.setOption({
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(255,255,255,0.95)',
          borderColor: '#e2e8f0',
          textStyle: { color: '#0f172a' },
          valueFormatter: (val) => {
            const n = Number(val)
            if (!Number.isFinite(n)) return '—'
            return n.toLocaleString('en-US', { maximumFractionDigits: 2, minimumFractionDigits: 0 })
          }
        },
        grid: { left: '3%', right: '3%', bottom: '3%', top: '12%', containLabel: true },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: [],
          axisLine: { lineStyle: { color: '#cbd5e1' } },
          axisLabel: { color: '#64748b' }
        },
        yAxis: {
          type: 'value',
          min: 0,
          splitLine: { lineStyle: { color: 'rgba(148, 163, 184, 0.35)' } },
          axisLabel: {
            color: '#64748b',
            formatter: (val) => this.formatLineAxisNum(val)
          }
        },
        series: [
          {
            name: 'BTC',
            type: 'line',
            smooth: true,
            areaStyle: { color: 'rgba(232, 121, 201, 0.12)' },
            lineStyle: { color: COL.btc, width: 2 },
            data: []
          },
          {
            name: 'ETH',
            type: 'line',
            smooth: true,
            areaStyle: { color: 'rgba(96, 165, 250, 0.12)' },
            lineStyle: { color: COL.eth, width: 2 },
            data: []
          },
          {
            name: 'USDT',
            type: 'line',
            smooth: true,
            areaStyle: { color: 'rgba(34, 211, 238, 0.12)' },
            lineStyle: { color: COL.usdt, width: 2 },
            data: []
          }
        ]
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.dash {
  border-radius: 16px;
  padding: 4px 0 8px;
  margin: 0;
}

.dash__row1 {
  margin-bottom: 20px;
}

.dash__row2 {
  margin-bottom: 20px;
}

.dash-balance {
  position: relative;
  border-radius: 16px;
  padding: 20px 20px 16px;
  color: #fff;
  background: linear-gradient( 221deg, #0850F0 0%, #155DFC 7.39%, #00B7FF 100%);
  box-shadow: 0px 8px 30px 0px rgba(79,70,229,0.18);
  border-radius: 24px 24px 24px 24px;
  min-height: 298px;
  display: flex;
  flex-direction: column;
}

.dash-balance__row1 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}

.dash-balance__label {
  font-size: 14px;
  opacity: 0.95;
}

.dash-balance__pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  background: rgba(255, 255, 255, 0.2);
  &.is-up {
    background: rgba(16, 185, 129, 0.35);
  }
  &.is-down {
    background: rgba(248, 113, 113, 0.35);
  }
}

.dash-balance__pill-ico {
  width: 14px;
  height: 14px;
  object-fit: contain;
}

.dash-balance__value {
  font-size: 28px;
  font-weight: 800;
  letter-spacing: 0.02em;
  line-height: 1.2;
}

.dash-balance__hint {
  font-size: 12px;
  opacity: 0.85;
  margin-bottom: 12px;
}

.dash-balance__stats {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  margin-top: auto;
  margin-bottom: 12px;
  padding-top: 8px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}

.dash-balance__subl {
  font-size: 11px;
  opacity: 0.8;
  margin-bottom: 4px;
}

.dash-balance__subv {
  font-size: 15px;
  font-weight: 600;
}

.dash-balance__btn {
  width: 100%;
  height: 44px;
  border: none;
  border-radius: 10px;
  color: #fff !important;
  background: rgba(255, 255, 255, 0.18) !important;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  &:hover {
    background: rgba(255, 255, 255, 0.28) !important;
    color: #fff !important;
  }
}

.dash-balance__btn-ico {
  width: 18px;
  height: 18px;
  object-fit: contain;
}

.dash-metrics {
  margin: 0 !important;
}

/* 与 UI 图：半透明白卡；上：图标+标题+下拉；下：左数字+单位、右趋势胶囊；行间距 38px */
.metric-card {
  position: relative;
  box-sizing: border-box;
  height: 137px;
  background: rgba(255, 255, 255, 0.6);
  box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.02);
  border-radius: 24px;
  padding: 21px;
  margin-bottom: 12px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 38px;
}

.metric-card__head {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex-shrink: 0;
}

.metric-card__head-left {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.metric-card__ico {
  width: 22px;
  height: 22px;
  object-fit: contain;
  flex-shrink: 0;
}

.metric-card__title {
  font-size: 14px;
  font-weight: 600;
  color: #334155;
}

.metric-card__sel {
  width: 88px;
  flex-shrink: 0;
  ::v-deep .el-input__inner {
    height: 30px;
    line-height: 30px;
    font-size: 12px;
    font-weight: 500;
    color: #0f172a;
    border-radius: 8px;
    background: #fff;
    border: 1px solid #e2e8f0;
    padding: 0 8px 0 10px;
  }
  ::v-deep .el-input__suffix {
    right: 4px;
  }
}

.metric-card__data-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 8px 12px;
  min-width: 0;
  flex: 1;
  min-height: 0;
}

.metric-card__value-line {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  flex-wrap: nowrap;
  gap: 6px 8px;
  min-width: 0;
  flex: 1;
}

.metric-card__num {
  font-size: 24px;
  font-weight: 800;
  color: #0f172a;
  letter-spacing: 0.02em;
  line-height: 1.15;
}

.metric-card__unit {
  font-size: 14px;
  font-weight: 500;
  color: #94a3b8;
}

.metric-card__pill {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  flex-shrink: 0;
  gap: 5px;
  max-width: 48%;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.35;
  &.is-down-pill {
    background: rgba(16, 185, 129, 0.14);
    color: #059669;
  }
  &.is-up-pill {
    background: rgba(239, 68, 68, 0.12);
    color: #dc2626;
  }
}

.metric-card__pill-ico {
  width: 12px;
  height: 12px;
  object-fit: contain;
  flex-shrink: 0;
}

.metric-card__pill-txt {
  word-break: break-all;
}

.dash-panel {
  background: #fff;
  border-radius: 16px;
  padding: 18px 18px 16px;
  border: 1px solid rgba(226, 232, 240, 0.9);
  box-shadow: 0 4px 20px rgba(15, 23, 42, 0.06);
  min-height: 200px;
}

.dash-panel__h {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 8px;
}

.dash-panel__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  flex-wrap: wrap;
  gap: 8px;
}

.dash-panel__legend {
  display: flex;
  gap: 16px;
  font-size: 12px;
  color: #64748b;
  margin: 0 0 4px 4px;
}

.lgd {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 2px;
  margin-right: 4px;
  vertical-align: middle;
}
.lgd--btc {
  background: #e879c9;
}
.lgd--eth {
  background: #60a5fa;
}
.lgd--usdt {
  background: #22d3ee;
}

.dash-panel__chart {
  width: 100%;
  height: 260px;
}
.dash-panel__chart--pie {
  height: 220px;
}

.dash-legend {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 8px;
  font-size: 12px;
  color: #64748b;
}
.dash-legend__coin {
  font-weight: 600;
  color: #0f172a;
  margin-right: 8px;
}

.dash-panel__all {
  font-size: 13px;
  color: #2563eb;
  text-decoration: none;
  .arr {
    margin-left: 2px;
  }
  &:hover {
    text-decoration: underline;
  }
}

.dash-table-wrap {
  margin-top: 0;
  padding: 20px 18px 16px;
}

::v-deep .dash-table {
  th {
    color: #64748b;
    font-weight: 500;
  }
  .cell {
    color: #334155;
  }
}

.cell-muted {
  color: #64748b;
  font-size: 13px;
}
.cell-time {
  font-size: 12px;
  white-space: nowrap;
}
.cell-arrival {
  color: #10b981;
  font-weight: 500;
}

.coin-pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
}
.coin-pill--btc {
  background: rgba(232, 121, 201, 0.15);
  color: #9d174d;
}
.coin-pill--eth {
  background: rgba(96, 165, 250, 0.15);
  color: #1d4ed8;
}
.coin-pill--usdt {
  background: rgba(34, 211, 238, 0.12);
  color: #0e7490;
}
.coin-pill__ico {
  width: 16px;
  height: 16px;
  object-fit: contain;
}

.chain-pill {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 6px;
  background: #f1f5f9;
  font-size: 12px;
  color: #475569;
}
</style>
